// extracted by mini-css-extract-plugin
export default {"hint":"AdminWorks_hint__9rM-9","imagePreview":"AdminWorks_imagePreview__UvNSM","titleCell":"AdminWorks_titleCell__ugZuF"};